module.exports = __webpack_public_path__ + "img/logo_h.d1bd8818.png";